import { Container, useMediaQuery } from "@mui/material";
import React from "react";
import BG from "./Assets/bgc.png";
import Faqs from "./Faqs/Faqs";
import Team from "./Team/Team";

const Tfaqs = () => {
  const check = useMediaQuery("(max-width:900px)");

  return (
    <div
      style={{
        backgroundImage: `url(${BG}  )`,
        backgroundSize: "cover",
        padding: "40px 0px 40px 0px",
      }}
    >
      <Container maxWidth="xl">
        <div id="team">
          <Team />
        </div>
      </Container>
      <Container maxWidth="md">
        <div id="freq">
          <Faqs />
        </div>
      </Container>
    </div>
  );
};

export default Tfaqs;
